// removed by extract-text-webpack-plugin
module.exports = {"element":"ListAppElement__element___2ZCEJ","body":"ListAppElement__body___2XJZH","stats":"ListAppElement__stats___DP9VJ","icon":"ListAppElement__icon___eukoG","title":"ListAppElement__title___1Fm_p _typography__h6___1u75q _typography__headers___eO5yD _typography__text-ellipsis___tUHkx","desc":"ListAppElement__desc___202ih _typography__smallInfo___e4AsH _typography__headers___eO5yD"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/ListAppElement.scss
// module id = 548
// module chunks = 0